/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description Add Location
 */

import { ButtonProps, Button } from 'antd';
import { Link } from 'react-router-dom';
import { Plus } from '@icon-park/react';

import { getAddLocationPath } from 'utils/router';
import AccessControl from '../AccessControl';

/**
 * AddPracticeLocation
 * @param props
 */
const AddLocation: React.FC<ButtonProps> = (props) => {
	const newLocationButton = (
		<Button type='primary' icon={<Plus />} {...props}>
			{'New Location'}
		</Button>
	);

	return (
		<AccessControl permission='canAddLocations'>
			<Link to={getAddLocationPath()} key='add-location'>
				{newLocationButton}
			</Link>
		</AccessControl>
	);
};

export default AddLocation;
